/**
 * Checks if a key is an attribute.
 *
 * @param {string} key Key to check.
 * @return {boolean} Whether the key is an attribute.
 */
export const isAttribute = key => {
	return key?.startsWith( 'pa_' );
};
